<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">
      &times;
    </button>

    <div class="modal-body">
      <div class="modal-header">
        <h2>{{ mode === 'edit' ? ('package.modalEditTitle' | t:'Edit Package') : ('package.modalNewTitle' | t:'New Package') }}</h2>
      </div>

      <form [formGroup]="packageForm" (ngSubmit)="onSubmit()">
        <div class="form-section">
          <div class="section-title">Package Info</div>
          <div class="form-grid single-col">
            <div class="form-group">
              <label>{{ 'package.name' | t:'Package Name' }} *</label>
              <input type="text" formControlName="packageName" [placeholder]="'package.placeholder.name' | t:'Type package name'" />
              <div class="field-error" *ngIf="hasError('packageName', 'required')">Package name is required.</div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <div class="section-title">Limits</div>
          <div class="form-grid three-col">
            <div class="form-group">
              <label>{{ 'package.totalFlat' | t:'Total Flat' }} *</label>
              <input type="number" min="0" formControlName="totalFlat" (focus)="clearZeroOnFocus('totalFlat')" />
              <div class="field-error" *ngIf="hasError('totalFlat', 'required') || hasError('totalFlat', 'min')">Enter a valid flat limit.</div>
            </div>

            <div class="form-group">
              <label>{{ 'package.totalRenter' | t:'Total Renter' }} *</label>
              <input type="number" min="0" formControlName="totalRenter" (focus)="clearZeroOnFocus('totalRenter')" />
              <div class="field-error" *ngIf="hasError('totalRenter', 'required') || hasError('totalRenter', 'min')">Enter a valid renter limit.</div>
            </div>

            <div class="form-group">
              <label>{{ 'package.maxActiveEmployee' | t:'Subuser' }} *</label>
              <input type="number" min="0" formControlName="maxActiveEmployee" (focus)="clearZeroOnFocus('maxActiveEmployee')" />
              <div class="field-error" *ngIf="hasError('maxActiveEmployee', 'required') || hasError('maxActiveEmployee', 'min')">Enter a valid subuser limit.</div>
            </div>

            <div class="form-group">
              <label>{{ 'package.maxFileMemory' | t:'Max File Memory (MB)' }} *</label>
              <input type="number" min="0" formControlName="maxFileMemory" (focus)="clearZeroOnFocus('maxFileMemory')" />
              <div class="field-error" *ngIf="hasError('maxFileMemory', 'required') || hasError('maxFileMemory', 'min')">Enter a valid memory limit.</div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <div class="section-title">Pricing</div>
          <div class="form-grid two-col">
            <div class="form-group">
              <label>{{ 'package.priceMonthly' | t:'Monthly Price' }} *</label>
              <input type="number" min="0" step="0.01" formControlName="priceMonthly" (focus)="clearZeroOnFocus('priceMonthly')" />
              <div class="field-error" *ngIf="hasError('priceMonthly', 'required') || hasError('priceMonthly', 'min')">Enter a valid monthly price.</div>
            </div>

            <div class="form-group">
              <label>{{ 'package.priceYearly' | t:'Yearly Price' }} *</label>
              <input type="number" min="0" step="0.01" formControlName="priceYearly" (focus)="clearZeroOnFocus('priceYearly')" />
              <div class="field-error" *ngIf="hasError('priceYearly', 'required') || hasError('priceYearly', 'min')">Enter a valid yearly price.</div>
            </div>
          </div>
        </div>

        <div class="form-message error form-message-block" *ngIf="error">{{ error }}</div>

        <div class="form-actions">
          <button type="button" class="secondary-btn" [disabled]="isSubmitting" (click)="closeModal()">
            {{ 'common.close' | t:'Close' }}
          </button>
          <button class="PositiveBTN" type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('package.updateButton' | t:'Update Package') : ('package.addButton' | t:'Add Package')) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
